import { Directive } from '@angular/core';

@Directive({
  selector: '[groupTemplate]',
  standalone: true,
})
export class GroupTemplateDirective {}
